import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from '../app/home/home.component';
import { UserTestComponent } from '../app/user-test/user-test.component';
import { MerqueComponent } from '../app/merque/merque.component';
import { ContactoPageComponent } from '../app/contacto/contacto-page/contacto-page.component';
import { QuienesSomosComponent } from '../app/quienes-somos/quienes-somos.component';
import { RemaxComponent } from '../app/remax/remax.component';
import { ServiciosSolucionesComponent } from '../app/servicios-soluciones/servicios-soluciones.component';
import { ConsultaPagosComponent } from '../app/Servicios/consulta-pagos/consulta-pagos.component';
import { FirmaElectronicaComponent } from '../app/Servicios/firma-electronica/firma-electronica.component';
import { PagueAquiComponent } from '../app/Servicios/pague-aqui/pague-aqui.component';
import { PuntoPagoComponent } from '../app/Servicios/punto-pago/punto-pago.component';
import { SolicitudCreditoComponent } from '../app/Servicios/solicitud-credito/solicitud-credito.component';
import { ErroPageComponent } from '../app/erro-page/erro-page.component';
import { TerminosCondicionesComponent } from '../app/home/terminos-condiciones/terminos-condiciones.component';
import { AceptarTerminosCondicionesComponent } from '../app/home/aceptar-terminos-condiciones/aceptar-terminos-condiciones.component';
import { VirtualPagareComponent } from '../app/Servicios/firma-electronica/virtual-pagare/virtual-pagare.component';

const routes: Routes = [
  { path: '', component: HomeComponent ,  pathMatch: 'full'},
  { path: 'home', component: HomeComponent },
  { path: 'user', component: UserTestComponent },
  { path: 'merquellantas', component: MerqueComponent },
  { path: 'remaxPage', component: RemaxComponent },
  { path: 'contacto', component: ContactoPageComponent },
  { path: 'quienessomos', component: QuienesSomosComponent },
  { path: 'servicios-soluciones', component: ServiciosSolucionesComponent },
  { path: 'consulta-pago', component: ConsultaPagosComponent },
  { path: 'firma-electronica', component: FirmaElectronicaComponent },
  { path: 'firma-electronica/:token', component: FirmaElectronicaComponent },
  { path: 'pague-aqui', component: PagueAquiComponent },
  { path: 'punto-pago', component: PuntoPagoComponent },
  { path: 'solicitud-credito', component: SolicitudCreditoComponent },
  { path: 'pagina-error', component: ErroPageComponent },
  { path: 'terminos-condiciones', component: TerminosCondicionesComponent },
  { path: 'aceptar-terminos-condiciones', component: AceptarTerminosCondicionesComponent },
  { path: 'virtual-pagare', component: VirtualPagareComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes , {useHash: true}) ],
  exports: [RouterModule],
})
export class AppRoutingModule {}

export const routingComponents = [FirmaElectronicaComponent];
